import moment from 'moment'
import {
    StyledHistoryList,
    StyledHistoryListItem,
    StyledHistoryAvatar,
    StyledHistoryContent,
    StyledHistoryHeader,
    StyledHistoryUser,
    StyledHistoryTime,
    StyledHistoryAction,
    StyledHistoryProfileCircle,
} from 'features/Booking/ui/components/History/style'
import { useOrderHistoryQuery } from 'entities/orderHistory/model'
import { useSelector } from 'react-redux'
import { selectBookingOrderId } from 'features/Booking/model/slices'
import { useAllUsersQuery } from 'entities/users/model/useAllUsersQuery'

const Avatar = ({ readUrl }: { readUrl?: string }) =>
    readUrl ? (
        <StyledHistoryAvatar src={readUrl} alt='' />
    ) : (
        <StyledHistoryProfileCircle />
    )

export const History = () => {
    const orderId = useSelector(selectBookingOrderId)
    const { orderHistory } = useOrderHistoryQuery(orderId)
    const { allUsers } = useAllUsersQuery()

    const getUser = (userId: number) =>
        allUsers.find(user => user.id === userId)

    return (
        <StyledHistoryList>
            {orderHistory.map(item => {
                const user = getUser(item.adminId)
                const name = user
                    ? user.user_ad_personal_info?.surname &&
                      user.user_ad_personal_info?.first_name
                        ? `${user.user_ad_personal_info.surname} ${user.user_ad_personal_info.first_name}`
                        : user.username
                    : 'Пользователь'

                return (
                    <StyledHistoryListItem key={item.createdAt.toISOString()}>
                        <Avatar
                            readUrl={
                                user?.user_ad_personal_info?.profile_photo
                                    ?.read_url
                            }
                        />
                        <StyledHistoryContent>
                            <StyledHistoryHeader>
                                <StyledHistoryUser>{name}</StyledHistoryUser>
                                <StyledHistoryTime>
                                    {moment(item.createdAt).fromNow()}
                                </StyledHistoryTime>
                            </StyledHistoryHeader>
                            <StyledHistoryAction>
                                {item.description}
                            </StyledHistoryAction>
                        </StyledHistoryContent>
                    </StyledHistoryListItem>
                )
            })}
        </StyledHistoryList>
    )
}
